import { triggerAnalytics } from './analytics-utils';

export default class ErrorEvents {
  // 7.39.17 Errors
  postPageError = (message, code) => {
    triggerAnalytics('pathToProNetwork.error.post-page', {
      message,
      code
    });
  };
}
